export const useStyles = () => {
    return {
        container: {
            display: 'flex',
            alignItems: 'center',
            gap: 1, 
        },
        icon: {
            color: 'blue.main',
            padding: 0
        },
        list: {
            display: 'flex',
            flexDirection: 'column',
        }
    }
}